import React from "react";

import { TCustomIcon } from "../../types";

const BurgerMenu = ({ fill, strokeWidth, stroke, className }: TCustomIcon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill ? fill : "none"}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth ? strokeWidth : 1.5}
      stroke={stroke ? stroke : "currentColor"}
      className={className ? className : "h-6 w-6"}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  );
};

export default BurgerMenu;
